module.exports = __webpack_public_path__ + "assets/2230eb29d36f255fb36b2447f9f23b1b.svg";